import {
  CustomerIndicatorInterface,
  DateTreated,
} from '@/core/domain/people/Customers/Customers.types';
import formatterNumber from '@/utils/number/formatterNumber';
import { Card, Col, Row, Statistic } from 'antd';

interface Props {
  customersIndicators?: CustomerIndicatorInterface;
  dateTreated: DateTreated;
  baseColor: string[];
}

export default function CustomerStaticsIndicators({
  customersIndicators,
  dateTreated,
  baseColor,
}: Props) {
  const [maleColor, femaleColor, unspecifiedColor] = baseColor;
  return (
    <Row gutter={[24, 24]}>
      <Col span={24} md={12} xl={8}>
        <Card style={{ borderRadius: 8 }}>
          <Statistic
            title="Quantidade de Homens por período"
            value={formatterNumber(dateTreated.maleCustomersCount || 0, {
              maximumFractionDigits: 2,
            })}
            valueStyle={{ color: maleColor }}
          />

          <Statistic
            title="Quantidade total de Homens no sistema"
            value={formatterNumber(
              customersIndicators?.customerGender.maleCustomersCount || 0,
              {
                maximumFractionDigits: 2,
              },
            )}
            valueStyle={{ color: maleColor }}
          />
        </Card>
      </Col>

      <Col span={24} md={12} xl={8}>
        <Card style={{ borderRadius: 8 }}>
          <Statistic
            title="Quantidade de Mulheres por período"
            value={formatterNumber(dateTreated.femaleCustomersCount || 0, {
              maximumFractionDigits: 2,
            })}
            valueStyle={{ color: femaleColor }}
          />

          <Statistic
            title="Quantidade total de Mulheres no sistema"
            value={formatterNumber(
              customersIndicators?.customerGender.femaleCustomersCount || 0,
              {
                maximumFractionDigits: 2,
              },
            )}
            valueStyle={{ color: femaleColor }}
          />
        </Card>
      </Col>

      <Col span={24} md={24} xl={8}>
        <Card style={{ borderRadius: 8 }}>
          <Statistic
            title="Quantidade sem gênero definido por período"
            value={formatterNumber(
              dateTreated.genderUnspecifiedCustomersCount || 0,
              {
                maximumFractionDigits: 2,
              },
            )}
            valueStyle={{ color: unspecifiedColor }}
          />

          <Statistic
            title="Quantidade total sem gênero definido no sistema"
            value={formatterNumber(
              customersIndicators?.customerGender
                .genderUnspecifiedCustomersCount || 0,
              {
                maximumFractionDigits: 2,
              },
            )}
            valueStyle={{ color: unspecifiedColor }}
          />
        </Card>
      </Col>

      <Col span={24} md={12} xl={8}>
        <Card style={{ borderRadius: 8 }}>
          <Statistic
            title="Idade média dos Homens por período"
            value={formatterNumber(dateTreated.averageAgeMaleCustomers || 0, {
              maximumFractionDigits: 2,
            })}
            valueStyle={{ color: maleColor }}
            suffix="Anos"
          />

          <Statistic
            title="Idade média dos Homens por período no sistema"
            value={formatterNumber(
              customersIndicators?.customerAge.averageAgeMaleCustomers || 0,
              {
                maximumFractionDigits: 2,
              },
            )}
            valueStyle={{ color: maleColor }}
            suffix="Anos"
          />
        </Card>
      </Col>

      <Col span={24} md={12} xl={8}>
        <Card style={{ borderRadius: 8 }}>
          <Statistic
            title="Idade média das Mulheres por período"
            value={formatterNumber(dateTreated.averageAgeFemaleCustomers || 0, {
              maximumFractionDigits: 2,
            })}
            valueStyle={{ color: femaleColor }}
            suffix="Anos"
          />

          <Statistic
            title="Idade média das Mulheres no sistema"
            value={formatterNumber(
              customersIndicators?.customerAge.averageAgeFemaleCustomers || 0,
              {
                maximumFractionDigits: 2,
              },
            )}
            valueStyle={{ color: femaleColor }}
            suffix="Anos"
          />
        </Card>
      </Col>

      <Col span={24} md={24} xl={8}>
        <Card style={{ borderRadius: 8 }}>
          <Statistic
            title="Idade média sem gênero definido por período"
            value={formatterNumber(
              dateTreated.averageAgeGenderUnspecifiedCustomers || 0,
              {
                maximumFractionDigits: 2,
              },
            )}
            valueStyle={{ color: unspecifiedColor }}
            suffix="Anos"
          />

          <Statistic
            title="Idade média sem gênero definido no sistema"
            value={formatterNumber(
              customersIndicators?.customerAge
                .averageAgeGenderUnspecifiedCustomers || 0,
              {
                maximumFractionDigits: 2,
              },
            )}
            valueStyle={{ color: unspecifiedColor }}
            suffix="Anos"
          />
        </Card>
      </Col>
    </Row>
  );
}
